module.exports = __webpack_public_path__ + "static/EWY_Kirsty_social-70bb41ae7393ef08938f264ac7c0dad8.mp4";